const longText = `
Diese Seite ist bewusst noch nicht ausgebaut. Die Avatar implementation ist bereits erledigt. Es gibt aber vieles, was man hier im Rahmen kleinerer Übungsprojekte ausprobieren kann. Die Profilseite soll grundsätzliche Einstellungsänderungen ermöglichen. Sprechen Sie wünsche und Ideen mit dem Administrator ab.
`;

export default longText;
